var disclosureToggle = document.querySelectorAll('[data-disclosure-toggle]');

function toggleState(item) {
  var state = item.getAttribute('aria-expanded');

  if (state === 'true') {
    state = false;
  } else {
    state = true;
  }

  item.setAttribute('aria-expanded', state);
}

disclosureToggle.forEach(function (toggle) {
  toggle.addEventListener('click', function () {
    toggleState(toggle);
  });
  toggle.setAttribute('aria-expanded', false);
});